module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-30.57f39084.JPG";